"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _Message = _interopRequireDefault(require("../Message"));
var _Spinner = _interopRequireDefault(require("../Spinner"));
var _bem = _interopRequireDefault(require("../../utils/bem"));
var _Text = _interopRequireDefault(require("./Text"));
var _Field = _interopRequireDefault(require("./Field"));
var _Input = _interopRequireDefault(require("./Input"));
var _Select = _interopRequireDefault(require("./Select"));
var _Button = _interopRequireDefault(require("./Button"));
var _Toggle = _interopRequireDefault(require("./Toggle"));
var _Upload = _interopRequireDefault(require("./Upload"));
var _Actions = _interopRequireDefault(require("./Actions"));
var _ImageSet = _interopRequireDefault(require("./ImageSet"));
require("./form.less");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children"];
var _class, _Form;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Context = /*#__PURE__*/_react["default"].createContext();
_Field["default"].contextType = Context;
_Actions["default"].contextType = Context;
var Form = exports["default"] = (0, _bem["default"])(_class = (_Form = /*#__PURE__*/function (_React$Component) {
  function Form() {
    var _this;
    _classCallCheck(this, Form);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Form, [].concat(args));
    _defineProperty(_this, "onSubmit", function (evt) {
      evt.preventDefault();
      _this.props.onSubmit(evt);
    });
    return _this;
  }
  _inherits(Form, _React$Component);
  return _createClass(Form, [{
    key: "getModifiers",
    value: function getModifiers() {
      var _this$props = this.props,
        loading = _this$props.loading,
        disabled = _this$props.disabled;
      return [loading ? 'loading' : null, disabled ? 'disabled' : null];
    }
  }, {
    key: "render",
    value: function render() {
      var props = (0, _omit["default"])(this.props, Object.keys(Form.propTypes));
      var children = props.children,
        rest = _objectWithoutProperties(props, _excluded);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(Context.Provider, {
        value: {
          disabled: this.props.disabled
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", _objectSpread(_objectSpread({}, rest), {}, {
          noValidate: true,
          onSubmit: this.onSubmit,
          className: this.getBlockClass(),
          children: [this.renderError(), this.renderSpinner(), children]
        }))
      });
    }
  }, {
    key: "renderError",
    value: function renderError() {
      var error = this.props.error;
      if (error) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Message["default"], {
          error: true,
          children: error.message
        });
      }
    }
  }, {
    key: "renderSpinner",
    value: function renderSpinner() {
      if (this.props.loading) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Spinner["default"], {});
      }
    }
  }]);
}(_react["default"].Component), _defineProperty(_Form, "Text", _Text["default"]), _defineProperty(_Form, "Field", _Field["default"]), _defineProperty(_Form, "Input", _Input["default"]), _defineProperty(_Form, "Select", _Select["default"]), _defineProperty(_Form, "Button", _Button["default"]), _defineProperty(_Form, "Toggle", _Toggle["default"]), _defineProperty(_Form, "Upload", _Upload["default"]), _defineProperty(_Form, "Actions", _Actions["default"]), _defineProperty(_Form, "ImageSet", _ImageSet["default"]), _Form)) || _class;
Form.propTypes = {
  onSubmit: _propTypes["default"].func.isRequired,
  error: _propTypes["default"].instanceOf(Error),
  message: _propTypes["default"].node,
  loading: _propTypes["default"].bool
};